<template>
  <div class="reference__accordion">
    <div class="accordion__item accordion__item--main" @click="toggleFilter">
      <div class="accordion__item-wrapper">
        <p class="accordion__title bold">Фильтрация и условия выборки</p>
        <img
          class="accordion__icon--down"
          src="../../../assets/icons/arrow-down.svg"
          alt=""
          :class="{ 'accordion__item--open': filterVisible }"
        />
      </div>
    </div>
    <div
      class="accordion__item accordion__item--sub accordion__item--readOnly"
      v-if="filterVisible"
    >
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Возраст клиента
        </span>
        – выбор возраста клиента в диапазоне
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Дата среза
        </span>
        – период за квартал/год
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Залог
        </span>
        – фильтрация кредитов по наличию залога
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Кредит с остатком
        </span>
        – фильтр, позволяющий включить или исключить кредитные контракты c
        остатком больше ноля или ноль (контракт/линия открыта, но задолженность
        отсутствует).
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Количество дней просрочки
        </span>
        – возможность выбора кредитных договоров в диапазоне дней просрочки
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Новый заемщик
        </span>
        – фильтр, позволяющий выбрать показатели только по новым заемщикам (не
        имевшим ранее кредитной истории)
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Оператор госпрограммы
        </span>
        – оператор, через которого реализуются государственные программы
        (Нацбанк РК, НУХ «Байтерек», НУХ «КазАгро» и т.д.)
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Отрасль
        </span>
        - перечень отраслей экономики.
        <span class="bold">Сокращенный справочник ПКБ.</span>
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Продукт
        </span>
        - наименование типа кредитного продукта.
        <span class="bold">Собственный справочник ПКБ. </span>
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Пол клиента
        </span>
        – выбор по гендерной принадлежности
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Размер кредита
        </span>
        –диапазон суммы <span class="bold">выданного</span> кредитного договора
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Размер предприятия
        </span>
        – размер субъекта предпринимательства согласно категорийности БНС АСПиР
        РК.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Размер просрочки
        </span>
        – выбор суммы просроченной задолженности в диапазоне
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Регион
        </span>
        - перечень наименований регионов Республики Казахстан. Регион
        указывается по адресу заемщика.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Вид реструктуризации и рефинансирования
        </span>
        – перечень видов реструктуризации и рефинансирования:
      </p>
      <div class="list">
        <p class="paragraph mt--1">
          1. "реструктуризация по характеристикам контракта за счет другого
          договора в этой организации"
        </p>
        <p class="paragraph mt--1">
          2. "рефинансирование по характеристикам контракта за счет другого
          договора в другой организации"
        </p>
        <p class="paragraph mt--1">
          3. "рефинансирование по характеристикам контракта, без пары"
        </p>
        <p class="paragraph mt--1">
          4. "реструктуризация, определенная косвенными методами внутри одного
          договора"
        </p>
        <p class="paragraph mt--1">
          5. "реструктуризация, определенная косвенными методами за счет другого
          договора - валютные-залоговые займы"
        </p>
        <p class="paragraph mt--1">
          6. "реструктуризация, определенная косвенными методами за счет другого
          договора - списанные"
        </p>
        <p class="paragraph mt--1">
          7. "реструктуризация, определенная косвенными методами за счет другого
          договора - погашенные с просрочкой - основной контракт с просрочкой за
          все время 90+"
        </p>
        <p class="paragraph mt--1">
          8. "реструктуризация, определенная косвенными методами за счет другого
          договора - погашенные с просрочкой - основной контракт без просрочки
          за все время 90+, но сумма не уменьшилась на текущую дату"
        </p>
        <p class="paragraph mt--1">
          9. "реструктуризация, определенная косвенными методами за счет другого
          договора - погашенные без просрочки - основной контракт с просрочкой
          за все время 90+"
        </p>
        <p class="paragraph mt--1">
          10. "реструктуризация, определенная косвенными методами за счет
          другого договора - погашенные без просрочки - основной контракт без
          просрочки за все время 90+, но сумма не уменьшилась на текущую дату"
        </p>
        <p class="paragraph mt--1">
          11. "рефинансирование, определенное косвенными методами за счет
          другого договора в другой организации - валютные-залоговые займы"
        </p>
        <p class="paragraph mt--1">
          12. "рефинансирование, определенное косвенными методами за счет
          другого договора в другой организации"
        </p>
      </div>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Розничные кредиты ИП
        </span>
        – фильтр, позволяющий включить или исключить розничные кредиты,
        получателями которых являются ИП, то есть субъекты, ранее оформлявшие
        бизнес-кредиты в статусе ИП.
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Размер просрочки
        </span>
        – выбор суммы просроченной задолженности в диапазоне
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Размер просрочки
        </span>
        – выбор суммы просроченной задолженности в диапазоне
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Сегмент кредитора
        </span>
        - включает в себя перечень сегментов финансовых институтов (
        <span class="bold">только действующих</span> в выбранный период),
        осуществляющих кредитную деятельность:
      </p>
      <p class="paragraph mt--1">
        - БВУ – включает в себя банки второго уровня;
      </p>
      <p class="paragraph mt--1">
        - МФО – включают в себя микрофинансовые организации (без кредитных
        товариществ и ломбардов);
      </p>
      <p class="paragraph mt--1">
        - Ломбарды - включают в себя ломбарды и комиссионные магазины;
      </p>
      <p class="paragraph mt--1">
        - КТ – включают в себя кредитные товарищества;
      </p>
      <p class="paragraph mt--1">
        - ГОС - включают в себя организации с государственным участием, а также
        организации, предоставляющие гос. услуги; Необходимо обратить внимание,
        что займы Отбасы банка – относится к БВУ.
      </p>
      <p class="paragraph mt--1">
        - Финансовые услуги - включают в себя ипотечные, лизинговые,
        факторинговые организации и организации, предоставляющие товары/услуги в
        рассрочку;
      </p>
      <p class="paragraph mt--1">
        - Прочие - включают в себя страховые организации, телекоммуникационных
        операторов, субъектов естественных монополий, кредитных брокеров,
        коллекторские агентства и иные категории
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Срок кредита
        </span>
        – выбор диапазона срока, на который заключен кредитный договор
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Списанный контракт
        </span>
        - к списанным контрактам относятся кредитные контракты, имеющие
        следующие статусы:
      </p>
      <p class="paragraph mt--1">
        - уступка/переуступка права требования по кредиту другому лицу;
      </p>
      <p class="paragraph mt--1">
        - ссудная задолженность списана за баланс;
      </p>
      <p class="paragraph mt--1">
        - ссудная/дебиторская задолженность списана на убытки;
      </p>
      <p class="paragraph mt--1">
        - задолженности, списанные на внесистемный учет;
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Тип валюты
        </span>
        - наименование валюты кредитного контракта (все, тенге, инвалюта)
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Тип бизнеса
        </span>
        - наименование типов субъектов, которым выдаются кредиты (ИП, розничные
        кредиты ИП, юридическое лицо)
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Уровень NPL
        </span>
        – выбор диапазона количества дней просрочки
      </p>
      <p class="paragraph mt--1">
        <span class="text--blue bold">
          Условно-списанный контракт
        </span>
        - кредитные контракты с количеством дней просрочки более 360 дней, не
        списанные за баланс у провайдера
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterVisible: false,
    };
  },
  methods: {
    toggleFilter() {
      this.filterVisible = !this.filterVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.reference {
  margin-bottom: 12.6rem;
  &__accordion {
    background: #f1f9ff;
    &:nth-child(even) {
      background-color: transparent;
    }
  }
  &__wrapper {
    max-width: 1110px;
    width: 100%;
    padding: 0 45px;
    margin: auto;
    &__cuttext {
      width: 100%;
    }
  }
}
.accordion {
  &__item {
    padding: 2rem;
    //height: 6.3rem;
    cursor: pointer;
    &--readOnly {
      cursor: auto;
    }
    &--open {
      transform: rotate(180deg);
    }
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    &--sub {
      height: auto;
      border-top: 1px solid rgba(0, 0, 0, 0.2);
      padding-left: 8rem;
      font-size: 16px;
    }
    &--main {
    }
  }
  &__icon {
    width: 3rem;
    height: 3rem;
    &--down {
    }
  }
  &__title {
    color: #005177;
    font-size: 14px;
    display: flex;
    align-items: center;
    &--secondary {
      margin-left: 3.1rem;
      width: 100%;
      font-size: 16px;
    }
  }
}
.list {
  margin-left: 2rem;
}
</style>
